import { Ionicons } from '@expo/vector-icons';
import * as WebBrowser from 'expo-web-browser';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

interface ActionInfoModalProps {
  visible: boolean;
  title: string | null;
  description: string | null;
  infoUrl?: string | null;
  infoLabel?: string | null;
  onClose: () => void;
}

export default function ActionInfoModal({
  visible,
  title,
  description,
  infoUrl,
  infoLabel,
  onClose,
}: ActionInfoModalProps) {
  const { t } = useTranslation();
  const handleOpenLink = async () => {
    if (!infoUrl) return;
    await WebBrowser.openBrowserAsync(infoUrl, {
      presentationStyle: WebBrowser.WebBrowserPresentationStyle.PAGE_SHEET,
      toolbarColor: '#FBEFE3',
      controlsColor: '#CD7728',
    });
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onClose}
    >
      <Pressable style={styles.modalOverlay} onPress={onClose}>
        <Pressable style={styles.modalContent} onPress={() => {}}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalTitle}>{title}</Text>
            <TouchableOpacity onPress={onClose} hitSlop={8}>
              <Ionicons name="close" size={24} color="#000" />
            </TouchableOpacity>
          </View>
          <Text style={styles.modalDescription}>{description}</Text>

          {infoUrl && (
            <TouchableOpacity
              style={styles.linkButton}
              onPress={handleOpenLink}
              activeOpacity={0.8}
            >
              <Text style={styles.linkButtonText}>
                {infoLabel
                  ? t('home.actionInfo.learnMoreWithLabel', { label: infoLabel })
                  : t('home.actionInfo.learnMore')}
              </Text>
              <Ionicons name="open-outline" size={18} color="#CD7728" />
            </TouchableOpacity>
          )}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  modalContent: {
    backgroundColor: '#FFF',
    borderRadius: 20,
    padding: 24,
    width: '100%',
    maxWidth: 400,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  modalTitle: {
    fontFamily: 'Inter_700Bold',
    fontSize: 20,
    color: '#000',
    flex: 1,
    marginRight: 12,
  },
  modalDescription: {
    fontFamily: 'Inter_400Regular',
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
  linkButton: {
    marginTop: 20,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    backgroundColor: '#FFF4E6',
    borderWidth: 1,
    borderColor: '#FCC189',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  linkButtonText: {
    fontFamily: 'Inter_600SemiBold',
    fontSize: 13,
    color: '#CD7728',
    flex: 1,
  },
});
